import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IProductCard } from "@/shared/types/feed"
import { IRecommendationsState } from "./types"

const initialState: IRecommendationsState = {
	recommendations: [],
	loading: false,
	error: null,
}

const singleProductSlice = createSlice({
	name: "singleProduct",
	initialState,
	reducers: {
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload
		},
		setError: (state, action: PayloadAction<string>) => {
			state.error = action.payload
		},
		setRecommendations: (state, action: PayloadAction<IProductCard[]>) => {
			state.recommendations = action.payload
			state.loading = false
		},
		clearError: state => {
			state.error = null
		},
	},
})

export const { setLoading, setError, setRecommendations } = singleProductSlice.actions
export default singleProductSlice.reducer
